import { defineComponent as _defineComponent } from 'vue';
import { useId } from "reka-ui";
import { provide } from "vue";
import { cn } from 'Components/primitives/utils';
import { FORM_ITEM_INJECTION_KEY } from "./injectionKeys";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormItem',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const id = useId();
        provide(FORM_ITEM_INJECTION_KEY, id);
        const __returned__ = { props, id, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
